import { World } from './3d/World.js';
import { ScrollManager } from './utils/ScrollManager.js';
import { Overlay } from './ui/Overlay.js';

class App {
    constructor() {
        this.world = new World(document.querySelector('#canvas-container'));
        this.scrollManager = new ScrollManager(this.world);
        this.overlay = new Overlay(this.scrollManager);

        this.init();
    }

    init() {
        // Start the render loop
        this.world.animate();

        // Handle resize
        window.addEventListener('resize', () => {
            this.world.onResize();
        });

        this.setupVideoLightbox();
    }

    setupVideoLightbox() {
        const lightbox = document.getElementById('video-lightbox');
        const iframe = lightbox.querySelector('iframe');
        const video = lightbox.querySelector('video'); // Fixed: Re-added video selection
        const closeBtn = lightbox.querySelector('.close-btn'); // Fixed: Re-added closeBtn selection

        const updateURL = (videoId) => {
            if (videoId) {
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.set('video', videoId);
                history.pushState({ video: videoId }, '', newUrl);
            } else {
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.delete('video');
                history.pushState({}, '', newUrl);
            }
        };

        const closeLightbox = () => {
            lightbox.classList.remove('active');
            video.pause();
            video.src = "";
            video.style.display = 'none';
            iframe.src = "";
            iframe.style.display = 'none';
            updateURL(null); // Clear URL
        };

        const openLightbox = (src, type = 'video') => {
            lightbox.classList.add('active');

            // If it's a YouTube ID, update URL
            if (type === 'youtube') {
                updateURL(src);
                video.style.display = 'none';
                iframe.style.display = 'block';
                iframe.src = `https://www.youtube.com/embed/${src}?autoplay=1`;
            } else {
                iframe.style.display = 'none';
                video.style.display = 'block';
                video.src = src;
                video.play().catch(e => console.error("Video play failed", e));
            }
        };

        // Event Listener from World
        window.addEventListener('open-video-lightbox', (e) => {
            if (e.detail && e.detail.src) {
                openLightbox(e.detail.src, e.detail.type || 'video');
            }
        });

        // Close actions
        closeBtn.addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', (e) => {
            if (e.target === lightbox) closeLightbox();
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && lightbox.classList.contains('active')) {
                closeLightbox();
            }
        });

        // Check URL on Load
        const urlParams = new URLSearchParams(window.location.search);
        const videoId = urlParams.get('video');
        if (videoId) {
            // Wait a moment for things to init? Or just open.
            console.log("Opening video from URL:", videoId);
            openLightbox(videoId, 'youtube');
        }
    }
}

// Initialize app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {

    // Mobile Detection Strategy
    // We consider 'Mobile' typically phones where 3D might be heavy or UX difficult
    const isMobile = window.innerWidth < 768 || (navigator.maxTouchPoints > 0 && /Android|iPhone/i.test(navigator.userAgent));
    const force3d = sessionStorage.getItem('force3d');

    if (isMobile && !force3d) {
        // Show Choice Overlay
        const overlay = document.getElementById('mobile-choice-overlay');
        const btnLite = document.getElementById('btn-lite');
        const btnImmersive = document.getElementById('btn-immersive');

        if (overlay) {
            overlay.style.display = 'flex'; // Show Flex

            // Handler: Lite Version
            btnLite.addEventListener('click', () => {
                overlay.style.opacity = 0;
                setTimeout(() => {
                    overlay.style.display = 'none';
                    // Load Mobile Lite Module dynamically
                    import('./mobile-lite/MobileLite.js')
                        .then(module => {
                            new module.MobileLite();
                        })
                        .catch(err => console.error("Failed to load Mobile Lite:", err));
                }, 300);
            });

            // Handler: Immersive Version
            btnImmersive.addEventListener('click', () => {
                overlay.style.opacity = 0;
                setTimeout(() => {
                    overlay.style.display = 'none';
                    // Launch Standard App
                    window.app = new App();
                }, 300);
            });
        } else {
            // Fallback if HTML missing
            window.app = new App();
        }

    } else {
        // Desktop / Tablet OR Mobile with Force 3D -> Direct Launch
        if (force3d) {
            console.log("🚀 Launching 3D (Forced by User)");
            // Optional: sessionStorage.removeItem('force3d'); // Uncomment to ask again on reload
        }
        window.app = new App();
    }
});

// UI Interactions
document.addEventListener('DOMContentLoaded', () => {
    const infoBtn = document.getElementById('info-btn');
    const infoTooltip = document.getElementById('info-tooltip');

    if (infoBtn && infoTooltip) {
        infoBtn.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent closing immediately
            infoBtn.classList.toggle('active');
            infoTooltip.classList.toggle('visible');
        });

        // Close on outside click
        document.addEventListener('click', (e) => {
            if (!infoBtn.contains(e.target) && !infoTooltip.contains(e.target)) {
                infoBtn.classList.remove('active');
                infoTooltip.classList.remove('visible');
            }
        });
    }
});
